import LocationsPage from '@/pages/locations/index'

export default function LivePage() {
  return <LocationsPage mode="live" />
}
